import { render, staticRenderFns } from "./usuarios_admin.vue?vue&type=template&id=5140958f&scoped=true&"
import script from "./usuarios_admin.vue?vue&type=script&lang=js&"
export * from "./usuarios_admin.vue?vue&type=script&lang=js&"
import style0 from "./usuarios_admin.vue?vue&type=style&index=0&id=5140958f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140958f",
  null
  
)

export default component.exports